import { Button, Space, Tooltip } from 'antd';
import {
  ZoomInOutlined,
  ZoomOutOutlined,
  ColumnWidthOutlined,
  PrinterOutlined,
  MailOutlined,
  ReloadOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';

// Stage R1: viewer chrome. Mirrors the tools from the existing invoice
// viewer (zoom in/out, fit width, print) plus an Email button. PDF
// download is intentionally absent — see docs/21 for the R1 limitation
// note.

export default function ReportToolbar({
  onBack,
  onZoomIn,
  onZoomOut,
  onFitWidth,
  onPrint,
  onRefresh,
  onEmail,
  emailDisabled,
  emailDisabledReason
}) {
  return (
    <Space wrap size="small" style={{ padding: '12px 16px' }}>
      {onBack && (
        <Button icon={<ArrowLeftOutlined />} onClick={onBack}>
          Back
        </Button>
      )}
      <Tooltip title="Zoom out">
        <Button icon={<ZoomOutOutlined />} onClick={onZoomOut} />
      </Tooltip>
      <Tooltip title="Fit width">
        <Button icon={<ColumnWidthOutlined />} onClick={onFitWidth} />
      </Tooltip>
      <Tooltip title="Zoom in">
        <Button icon={<ZoomInOutlined />} onClick={onZoomIn} />
      </Tooltip>
      <Tooltip title="Reload">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
      <Tooltip title="Print / save as PDF (browser dialog)">
        <Button type="primary" icon={<PrinterOutlined />} onClick={onPrint}>
          Print
        </Button>
      </Tooltip>
      <Tooltip title={emailDisabled ? emailDisabledReason : 'Email this report'}>
        <Button
          icon={<MailOutlined />}
          onClick={onEmail}
          disabled={emailDisabled}
        >
          Email
        </Button>
      </Tooltip>
    </Space>
  );
}
